export default {"src":"/_next/static/media/Congenital_Heart_Defects.c70ff72d.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};